import React from 'react';

/**
 * Realistic backlight sun behind Swamiji's head. Two layers, both guaranteed
 * circular by construction:
 *  - .hero__sun-glow:  big radial gradient — atmospheric halo (breathing).
 *  - .hero__sun-rays:  conic gradient (rays), masked to a circle, rotating
 *                      slowly. The radial-gradient mask makes the rays fade
 *                      to transparent at the edges, so they CAN'T streak
 *                      across the viewport.
 *
 * No SVG, no overlapping square boxes, no mix-blend-mode side effects.
 */
export const Sun: React.FC<{ animate?: boolean }> = ({ animate = true }) => (
  <div className="hero__sun" aria-hidden>
    <div className="hero__sun-rays" data-animate={animate ? 'true' : 'false'} />
    <div className="hero__sun-glow" data-animate={animate ? 'true' : 'false'} />
  </div>
);
